import React from 'react';
import { Form } from 'antd';
import CustomerTextInput from '../../inputs/customerTextInput/CustomerTextInput';
import CustomerSelectInput from '../../inputs/customerSelectInput/CustomerSelectInput';
import CustomerPhoneNumberInput from '../../inputs/customerPhoneInput/CustomerPhoneNumberInput';
import DefaultButton from '../../components/buttons/defaultButton/DefaultButton';
import useTranslation from '../../../hooks/translation/useTranslation';
import CustomerVerificationInput
  from '../../inputs/customerVerificationInput/CustomerVerificationInput';

function EditPhysicalProfile({
  handleSubmit,
  form,
  errors,
  options,
  setErrors,
}) {
  const { trans, currentLanguage, configInfo } = useTranslation();
  const citizenship = Form.useWatch('citizenship', form);

  const isGeorgian = configInfo?.countryCode === 'GE';

  return (
    <Form
      layout="vertical"
      onFinish={handleSubmit}
      form={form}
    >
      <div className="flex gap-1 flex-col lg:flex-row lg:gap-4">
        <CustomerTextInput
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }]}
          className="flex-1 font-bold"
          name="first_name"
          label={trans('first_name')}
          errorMessage={errors?.first_name}
        />
        <CustomerTextInput
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }]}
          className="flex-1 font-bold"
          name={citizenship === 1 && isGeorgian ? 'personal_number' : 'passport_number'}
          label={trans(isGeorgian ? 'id_number' : 'passport_number')}
          errorMessage={errors?.id_number}
        />
      </div>
      <div className="flex gap-1 flex-col lg:flex-row lg:gap-4">
        <CustomerTextInput
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }]}
          className="flex-1 font-bold"
          name="last_name"
          label={trans('last_name')}
          errorMessage={errors?.last_name}
        />
        <CustomerTextInput
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }]}
          className="flex-1 font-bold"
          name="email"
          label={trans('email')}
          errorMessage={errors?.email}
          disabled
        />
      </div>
      <div className="flex gap-1 flex-col lg:flex-row lg:gap-4">
        <CustomerSelectInput
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }]}
          options={options?.countries?.map((country) => ({
            value: country.id,
            label: country[`name_${currentLanguage === 'am' ? 'ka' : currentLanguage}`] || country.name_ka,
          }))}
          className="flex-1 white-background font-bold"
          name="citizenship"
          label={trans('citizenship')}
          required
          errorMessage={errors?.citizenship}
        />
        <CustomerPhoneNumberInput
          options={options?.countries?.map((country) => ({
            value: `${country.country_phone_code}`,
            label: country.country_phone_code,
          }))}
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }]}
          className="flex-1 white-background font-bold"
          name="phone_number"
          label={trans('phone_number')}
          selectName="country_phone_code"
          required
          errorMessage={errors?.phone_number}
        />
      </div>
      {isGeorgian && (
      <div className="flex gap-1 flex-col lg:flex-row lg:gap-4">
        <CustomerSelectInput
          options={options?.verifications?.map((verification) => ({
            value: verification.value,
            label: trans(verification.label),
          }))}
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }]}
          name="verification"
          disabled
          className="flex-1 white-background font-bold"
          label={trans('verification_method')}
        />
        <CustomerVerificationInput
          className="flex-1"
          name="verified"
          label="ნომერი"
          errors={errors}
          setErrors={setErrors}
          form={form}
        />
      </div>
      )}
      <div className="flex gap-1 flex-col lg:flex-row lg:gap-4">
        <CustomerSelectInput
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }]}
          options={options?.genders?.map((gender) => ({
            value: gender.value,
            label: trans(gender.label),
          }))}
          className="flex-1 white-background font-bold"
          name="gender"
          label={trans('gender')}
          required
          errorMessage={errors?.citizenship}
        />
        <DefaultButton className="flex-1 !p-0 min-h-[60px] mt-auto mb-6" type="submit">{trans('finish')}</DefaultButton>
      </div>
    </Form>
  );
}

export default EditPhysicalProfile;
